<template>
    <div class="row">
        <div class="col-md-4 col-sm-6 mb-50" v-for="e in equipments" :key="e.Id">
            <b-form-checkbox v-model="e.Selected" :value="e.Id">{{e.Name}} {{e.Code ? ['(',e.Code,')'].join('') : null}}</b-form-checkbox>
        </div>
        <div class="col-12 mt-50">
            <template v-for="(t,i) in types">
                <b-form-radio inline :key="'t'+i" v-model="debit.DebitType" :value="t.value">{{t.text}}</b-form-radio>
            </template>
        </div>
        <div class="col-12 text-right mt-1">
            <v-executer :loading="loading" text="Oluştur" :action="create"></v-executer>
        </div>
    </div>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import EmployeeOperationsApi from '@/api/employee-operations'
import { BFormCheckbox,BFormRadio } from 'bootstrap-vue'

export default {
    props:{
        id:[String,Number]
    },
    components:{
        BFormCheckbox,
        BFormRadio
    },
    data(){
        return{
            equipments:[],
            loading:false,
            types:[
                {text:"Normal",value:"Normal"},
                {text:"Yenileme",value:"Update"}
            ],
            debit:{
                PPEIds:[],
                DebitType:"Normal",
                EmployeeId:null,
                EmployeeType:"Driver"
            }
        }
    },
    mounted(){
        this.getEquipments()
    },  
    methods:{
        getEquipments(){
            HumanResourcesParameterApi.PersonalProtectiveEquipment.List().then(res=>{
                this.equipments = res.data.Data?.map(e=>{ return { ...e,Selected:false } })
            })
        },
        create(){
            this.loading = true
            this.debit.EmployeeId = this.id
            this.debit.PPEIds = this.equipments.filter(e=>e.Selected).map(e=>e.Id)
            EmployeeOperationsApi.PersonalProtectiveEquipment.Debit(this.debit).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>